import ComingSoon from '@/components/ComingSoon';

const Transfers = () => {
    return (
        <ComingSoon />
    );
};

export default Transfers;
